export default "__VITE_ASSET__DIE460fS__"